module.exports = __webpack_public_path__ + "static/media/focus-icon-3.331326d7.png";